<template>
  <div>
     <div class="centered-header">
      <h4 class="ui header" style="color: #092442;">
        <i class="clipboard outline icon"></i>
        <div class="content">
          {{ formattedTime() }}
        </div>
      </h4>
    </div>

    <div class="ui divider">
    </div>
    <table class="ui celled table">
      <thead>
        <tr>
          <th>Package Name</th>
          <th>Used Quantities</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="selectedPackage in visit.packages" :class="{positive: selectedPackage.quantity > 0}">
          <td>{{ getPackageName(selectedPackage) }}</td>
          <td>{{ selectedPackage.quantity || 0 }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    visit: { type: Object, required: true }
  },
  methods: {
    getPackageName(selectedPackage) {
      let quantity = selectedPackage.units ? selectedPackage.units : selectedPackage.quantity
      let packageName = selectedPackage.name + ' :: ' + selectedPackage.unit_price + ' × ' 
        + quantity

      if (selectedPackage.entities && selectedPackage.entities[0]) {
        packageName = selectedPackage.entities[0].name + ' :: ' + packageName
      }

      return packageName
    },
    formattedTime () {
      return window.moment(this.visit.time).format('DD/MM/YYYY hh:mm a')
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/packages-visits-components/ShowVisit.vue